// The search box shown above every Estimate Engine list. Controlled; Esc or the
// × clears it. `count` (optional) shows "n of total" while a search is active.
export default function ListSearchBox({ value, onChange, placeholder = "Search…", shown, total, style }) {
  const active = !!String(value || "").trim();
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 8, ...style }}>
      <div style={{ position: "relative" }}>
        <input
          type="search"
          aria-label="Search this list"
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Escape") onChange(""); }}
          style={{ width: 280, fontSize: 12.5, padding: "5px 26px 5px 9px", border: "1px solid var(--cs-border)", borderRadius: 6, background: "var(--surface)", color: "var(--text)" }}
        />
        {active && (
          <button
            type="button"
            aria-label="Clear search"
            onClick={() => onChange("")}
            style={{ position: "absolute", right: 4, top: "50%", transform: "translateY(-50%)", border: "none", background: "none", cursor: "pointer", color: "var(--text3)", fontSize: 14, lineHeight: 1 }}
          >×</button>
        )}
      </div>
      {active && total != null && (
        <span style={{ fontSize: 11.5, color: "var(--text3)" }}>{shown} of {total}</span>
      )}
    </div>
  );
}
